/**
 * 출석 스케줄 설정 데모 페이지 (Mock 버전)
 */

import React from 'react';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import DemoNavigation from '../components/DemoNavigation';

const mockSchedules = [
  { id: '1', student_name: '김민수', expected_time: '09:00', days: '월,화,수,목,금', grace_period: 10 },
  { id: '2', student_name: '이영희', expected_time: '10:00', days: '월,수,금', grace_period: 15 },
  { id: '3', student_name: '박지훈', expected_time: '14:00', days: '화,목,토', grace_period: 10 },
];

const DemoAttendanceSchedulePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-blue-600 text-white py-3 px-4 text-center">
        <p className="text-sm">📢 이것은 데모 페이지입니다. 모든 데이터는 가상 데이터이며, 데모 시연을 위해 주기적으로 업데이트되어 조금씩 변동될 수 있습니다.</p>
      </div>
      <DemoNavigation currentTitle="출석 스케줄 설정 (데모)" currentIcon={CalendarDaysIcon} />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow">
          <div className="px-6 py-4 border-b">
            <h2 className="text-2xl font-bold">출석 스케줄 관리</h2>
          </div>
          <div className="p-6">
            <table className="min-w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">학생명</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">예상 시간</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">출석 요일</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">여유 시간</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {mockSchedules.map((schedule) => (
                  <tr key={schedule.id}>
                    <td className="px-6 py-4 whitespace-nowrap font-medium">{schedule.student_name}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{schedule.expected_time}</td>
                    <td className="px-6 py-4">{schedule.days}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{schedule.grace_period}분</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="mt-6 text-center text-gray-500 text-sm">
              📢 데모 모드에서는 추가 및 수정이 불가능합니다.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoAttendanceSchedulePage;
